import React, { useState } from "react";
const AppContext = React.createContext()

// ========== REGEX EXPRESSIONS ==========
const usernameRegex = /^[A-Za-z]{2,50}$/;
const emailRegex = /^[A-Za-z0-9]{5,}@[a-z0-9]{3,}\.[a-z0-9.]{2,}$/;
const passwordRegex = /^[A-Za-z0-9@.$*?&_#!\-]{8,}$/;
const fullNameRegex = /^[A-Za-z\s]{3,60}$/;
const phoneRegex = /^(\+92|0)[0-9]{10}$/;
const messageRegex = /^.{10,500}$/;
const reasonRegex = /^.{10,200}$/;
const descriptionRegex = /^.{20,1000}$/;
const firstNameRegex = new RegExp(/^[A-Za-z]{2,}$/);
const lastNameRegex = new RegExp(/^[A-Za-z]{2,}$/);
const profileUrlRegex = new RegExp(
  /^https?:\/\/(www\.)?(linkedin|github)\.com\/[A-Za-z0-9_/-]{3,}$/,
);
// admin profile edit regexes
const locationRegex = new RegExp(/^[A-Za-z\s,]{3,}$/);
const websiteRegex = new RegExp(/^https?:\/\/[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/);

    const regExpChecker = (type, inp) => {
    switch (type) {
      case "firstname":
        if (!usernameRegex.test(inp))
          return "First name must be 2-50 letters only";
        return "";
case "lastname":
        if (!usernameRegex.test(inp))
          return "Last name must be 2-50 letters only";
        return "";

      case "email":
        if (!emailRegex.test(inp))
          return "Please enter a valid email address";
        return "";
    case "profileUrl":
      if (inp && !profileUrlRegex.test(inp))
        return "Enter a valid LinkedIn or GitHub URL";
      break;
    case "password":
        if (!passwordRegex.test(inp))
          return "Password must be 8+ characters";
        return "";

      case "fullName":
        if (!fullNameRegex.test(inp))
          return "Full name must be 3-60 letters only (no numbers)";
        return "";

      case "enrollEmail":
        if (!emailRegex.test(inp))
          return "Please enter a valid email address";
        return "";

      case "phone":
        if (!phoneRegex.test(inp))
          return "Enter valid Pakistani number e.g. +923001234567 or 03001234567";
        return "";
case "education":
        if (!inp)
          return "Please select your education level";
        return "";

      case "message":
        if (inp && !messageRegex.test(inp))
          return "Message must be between 10 and 500 characters";
        return "";

      // ✅ Yeh 2 cases andar aa gaye
      case "reason":
        if (!reasonRegex.test(inp))
          return "Reason must be between 10 and 200 characters";
        return "";

      case "description":
        if (!descriptionRegex.test(inp))
          return "Description must be between 20 and 1000 characters";
        return "";
    // admin profile edit cases
   

    case "location":
      if (!locationRegex.test(inp)) return "Enter a valid location";
      break;
    case "linkedin":
      if (inp && !profileUrlRegex.test(inp))
        return "Enter a valid LinkedIn or GitHub URL";
      break;
    case "website":
      if (inp && !websiteRegex.test(inp)) return "Enter a valid website URL";
      break;
    default:
      return "";
  }
  return "";
};

export const AppProvider = ({ children }) => {
  const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        setBaseUrl,
        regExpChecker,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
